import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "tailwindcss/tailwind.css";
import "./styles/styles.scss";
import { StoreProvider } from "./app/context/store";
import { AlertProvider } from "./app/context/alerts";
import ModalOpenCloseContextProvider from "./app/context/modalOpenCloseContext";
import { loadRuntimeConfig } from "./app/runtimeConfig";

const root = ReactDOM.createRoot(document.getElementById("root"));

async function init() {
	await loadRuntimeConfig();
	const { default: App } = await import("./App");
	root.render(
		<React.StrictMode>
			<StoreProvider>
				<AlertProvider>
					<ModalOpenCloseContextProvider>
						<App />
					</ModalOpenCloseContextProvider>
				</AlertProvider>
			</StoreProvider>
		</React.StrictMode>
	);
	reportWebVitals();
}

init();
